import React from "react";
import { Navigate } from "react-router-dom";

import async from "@/components/Async";

// All pages that rely on 3rd party components (other than MUI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "@/layouts/Auth";
import ErrorLayout from "@/layouts/Error";
import DashboardLayout from "@/layouts/Dashboard";

// Guards
import AuthGuard from "@/components/guards/AuthGuard";

// Auth components
import SignIn from "@/pages/auth/SignIn";
import SignUp from "@/pages/auth/SignUp";
import ResetPassword from "@/pages/auth/ResetPassword";
import Page404 from "@/pages/auth/Page404";

// Components

// Form components

// Icon components

// Page components
import Blank from "@/pages/pages/Blank";
import Pricing from "@/pages/pages/Pricing";
import Settings from "@/pages/pages/Settings";
import Chat from "@/pages/pages/Chat";

// Table components

// Documentation
import Firebase from "@/pages/docs/auth/Firebase";

// Landing

// Protected routes
import ProtectedPage from "@/pages/protected/ProtectedPage";

// Dashboard components
import UsersPage from "./pages/users/UsersPage";
import UserDetailsPage from "./pages/users/UserDetailsPage";
import UsersAuthenticationsPage from "./pages/users/UsersAuthenticationsPage";
import UserAuthenticationsPage from "./pages/users/UserAuthenticationsPage";

import Dashboard from "@/pages/dashboards/Default";
// Form components

// Icon components
const Profile = async(() => import("@/pages/pages/Profile"));

// Table components

// Chart components

// Maps components

const routes = [
  // {
  //   path: "pages",
  //   element: <DashboardLayout />,
  //   children: [
  //     {
  //       path: "profile",
  //       element: <Profile />,
  //     },
  //     {
  //       path: "settings",
  //       element: <Settings />,
  //     },
  //     {
  //       path: "pricing",
  //       element: <Pricing />,
  //     },
  //     {
  //       path: "chat",
  //       element: <Chat />,
  //     },
  //     {
  //       path: "blank",
  //       element: <Blank />,
  //     },
  //   ],
  // },
  {
    path: "users",
    element: <DashboardLayout />,
    children: [
      {
        path: "authentications",
        element: <UsersAuthenticationsPage />,
      },
      {
        path: "all",
        element: <UsersPage />,
      },
      
      { 
        path: ":email/authentications", 
        element: <UserAuthenticationsPage /> 
      },
    ],
  },
  {
    path: "users/:userId",
    element: <DashboardLayout />,
    children: [
      { index: true, element: <UserDetailsPage /> },
    ]
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "sign-in",
        element: <SignIn />,
      },
      {
        path: "sign-up",
        element: <SignUp />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
    ],
  },
  {
    path: "auth/firebase",
    element: <Firebase />,
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
    ],
  },
  {
    path: "dashboard",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
    ],
  },
  {
    path: "*",
    element: <ErrorLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
